import { useEffect, useMemo, useState } from "react";
import { Col, Typography, Layout, Space, Button, message, Input } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import Header160 from "../../header/header";
import styles from "../ingresosPOStyles.module.css";
import ProveedoresPOTable from "./ProveedoresPOTable";
import ProveedorPOForm from "./ProveedorPOForm";
import ProveedoresPOCards from "./ProveedoresPOCards";
import { getProveedoresPO, createProveedorPO, updateProveedorPO, deleteProveedorPO } from "../../../services/financiero/ingresosPO/proveedoresPOService";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../store/auth/selectors';

const { Title, Text } = Typography;

export default function ProveedoresPOPage() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");
  const appName = 'proveedores_ingresos_po';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const permissionAccess = permissions.priv_access === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await getProveedoresPO();
      setData(res);
    } catch (error) {
      message.error("Error cargando proveedores");
    }
    setLoading(false);
  };

  useEffect(() => {
    cargar();
  }, []);

  const dataFiltrada = useMemo(() => {
    if (!search) return data;
    const q = search.toLowerCase();
    return data.filter((p) =>
      p.nombre?.toLowerCase().includes(q) ||
      p.identificacion?.toLowerCase().includes(q) ||
      p.direccion?.toLowerCase().includes(q)
    );
  }, [data, search]);

  const handleCreate = () => {
    if (!permissionInsert) {
      message.warning("No tiene permisos para crear proveedores");
      return;
    }
    setEditing(null);
    setModalOpen(true);
  };

  const handleEdit = (record) => {
    if (!permissionUpdate) {
      message.warning("No tiene permisos para editar");
      return;
    }
    setEditing(record);
    setModalOpen(true);
  };

  const handleDelete = async (record) => {
    if (!permissionDelete) {
      message.warning("No tiene permisos para eliminar");
      return;
    }
    try {
      await deleteProveedorPO(record.oid, userLogin);
      message.success("Proveedor eliminado");
      cargar();
    } catch {
      message.error("Error eliminando proveedor");
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editing) {
        await updateProveedorPO(editing.oid, values, userLogin);
        message.success("Proveedor actualizado");
      } else {
        await createProveedorPO(values, userLogin);
        message.success("Proveedor creado");
      }
      setModalOpen(false);
      cargar();
    } catch {
      message.error("Error guardando proveedor");
    }
  };

  if (!permissionAccess) {
    return <div>No tiene permisos para acceder a este módulo</div>;
  }
  return (
    <div className={styles.ingresosPoModule}>
      <div className="container" style={{ paddingBottom: 20 }}>
        <Layout className="container">
          <div className="header-filter-container d-flex align-items-center justify-content-between" style={{ flexWrap: "wrap", gap: 16 }}>
            <Header160 />
            <Col flex="auto" style={{ textAlign: "center", minWidth: 260 }}>
              <Space direction="vertical" size={2} align="center">
                <Title level={4} style={{ margin: 0, color: "#042956", fontWeight: 600 }}>
                  Proveedores — Ingresos PO
                </Title>
                <Text style={{ color: "#6b7280", fontSize: 13 }}>
                  Catálogo de proveedores del módulo Financiero
                </Text>
                {permissionInsert && (
                  <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate} style={{ marginTop: 8 }}>
                    Nuevo proveedor
                  </Button>
                )}
              </Space>
            </Col>
          </div>
        </Layout>
      </div>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        <ProveedoresPOCards proveedores={data} />
        <Input
          allowClear
          placeholder="Buscar por nombre, identificación o dirección"
          prefix={<SearchOutlined />}
          style={{ maxWidth: 380, marginBottom: 16 }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <ProveedoresPOTable
          data={dataFiltrada}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          permissionDelete={permissionDelete}
          permissionUpdate={permissionUpdate}
        />
      </div>
      <ProveedorPOForm
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editing}
      />
    </div>
  );
}
